exports.default = {
  'sms_login': '短信登录',
  'pwd_login': '密码登录',
  'please_enter_your_mobile_number_or_email': '请输入手机号或邮箱',
  'please_enter_your_pwd': '请输入密码',
  'forgot_password': '忘记密码？',
  'no_account': '还没有账号？',
  'register_new_account': '注册新账号',
  'login_failed': '登录失败',
  'login_success': '登录成功',
  'verification_title': '请输入验证码',
  'code_sent_to_email': '验证码已经发送至您的邮箱',
  'code_sent_to_phone': '验证码已经发送至您的手机',
  'verification_sent': '验证码已经发送至您的邮箱或手机',
  'enter_password': '请输入您的密码',
  'enter_account_password': '请输入您账号的登录密码',
  'verification_failed': '验证失败',
  'verification_success': '验证成功',
  'not_received_code': '没有收到验证码? 稍后重发 ( {time} )',
  'resend_code': '没有收到验证码?点击重发',
  'continue': '继续',
  'back': '返回',
  'code_sent': '验证码已发送，请查收',
  'sms_retrieval_password': '手机找回密码',
  'mail_retrieval_password': '邮箱找回密码',
  'enter_mobile_number': '请输入手机号',
  'verification_code_input': '请输入验证码',
  'get_verification_code': '获取验证码',
  'please_set_the_password': '请设置密码',
  'enter_the_password_again': '再次输入密码',
  'reading_consent': '阅读并同意',
  'user_agreement': '《AgentStore服务协议及隐私条款》',
  'forget_reset': '重置',
  'existing_account_number': '已有账号？',
  'log_in_now': '立即登录',
  'enter_mail': '请输入邮箱',
  'please_enter_your_mobile_number': '请输入手机号码',
  'please_enter_the_verification_code': '请输入验证码',
  'please_confirm_the_password_again': '请再次确认密码',
  'please_keep_the_same_password_twice': '两次输入密码保持一致',
  'please_enter_your_email': '请输入邮箱',
  'input_the_phone_number_correctly': '请正确输入手机号码',
  'password_check_error': '密码必须包含8-16个字符，至少包含大小写字母、数字',
  'email_check_error': '请输入正确的邮箱地址',
  'login_title': '登录Paiteams',
  'login_title_prefix': '登录',
  'welcome_text': '欢迎回来！',
  'google_login': '使用Google账号登录',
  'phone_login': '手机登录',
  'email_login': '邮箱登录',
  'password_login': '密码登录',
  'or': '或者',
  'email_address': '邮箱地址',
  'email_placeholder': '请输入您的邮箱地址',
  'phone_number': '手机号码',
  'phone_placeholder': '请输入您的手机号码',
  'username_label': '手机号/邮箱',
  'username_placeholder': '请输入您的账号',
  'password_title': '请输入密码',
  'password_desc': '请输入您账号的登录密码',
  'login_button': '登录',
  'password_error': '密码错误',
  'mobile_registration': '手机注册',
  'mailbox_registration': '邮箱注册',
  'register': '注册',
  'authentication_failed': '认证失败',
  'invite_you': '邀请你使用 PAITEAMS',
  'welcome_use': '欢迎使用 PAITEAMS',
  'register_to_get': '注册即可领 ',
  'new_user_points': '新用户积分',
  'brand_logo_alt': 'PAITEAMS 标志',
  'back_home': '返回首页',
  'hero_title_prefix': '释放你的',
  'hero_title_highlight': '无限潜能',
  'hero_phrase_ready': '你的 AI 专家团队已准备就绪',
  'hero_phrase_workflows': '让复杂工作流更高效',
  'hero_phrase_deliver': '设计、开发、交付，一气呵成',
  'feature_automation': 'AI 驱动的工作流自动化',
  'feature_security': '企业级安全保障',
  'feature_collaboration': '无缝团队协作',
  'dialog_kicker': 'PAITEAMS 通行证',
  'dialog_title': '登录，继续你的创作',
  'dialog_subtitle': '使用验证码快速登录；新账号将自动完成注册。',
  'dialog_close': '关闭登录弹窗',
  'login_methods': '登录方式',
  'phone_code_login': '手机号登录',
  'email_code_login': '邮箱登录',
  'verification_code_label': '验证码',
  'phone_code_placeholder': '请输入6位短信验证码',
  'email_code_placeholder': '请输入6位邮箱验证码',
  'send_code': '获取验证码',
  'resend_after': '{time}秒后重发',
  'sending_code': '正在发送验证码…',
  'send_code_failed': '验证码发送失败，请稍后重试。',
  'verification_code_invalid': '请输入6位验证码',
  'please_enter_complete_code': '请输入完整的 6 位验证码。',
  'incorrect_verification_code': '验证码不正确，请重试。',
  'code_sent_to_contact': '验证码已发送至 {contact}',
  'edit_contact': '修改登录账号',
  'verification_digit': '第 {index} 位验证码',
  'verification_success_redirecting': '验证成功，正在跳转…',
  'verify_and_login': '验证并登录',
  'agreement_prefix': '我已阅读并同意',
  'terms_of_service': '用户服务协议',
  'terms': '服务条款',
  'privacy_policy': '隐私政策',
  'agreement_and': '与',
  'agreement_suffix': '。',
  'agreement_required': '请先阅读并同意相关协议',
  'other_login_methods': '其他方式登录',
  'login_in_progress': '正在登录',
  'login_error': '登录出错，请稍后重试。',
  'google_redirecting': '正在前往 Google',
  'google_redirect_failed': '暂时无法跳转到 Google 登录',
  'wechat_login': '微信登录',
  'wechat_login_pending': '微信登录对接中',
  'invite_invalid': '邀请码无效或已过期，仍可继续登录',
  'visual_eyebrow': 'YOUR AI CREW',
  'visual_title': '把灵感，变成真正的作品。',
  'visual_description': '登录后继续对话、保存项目，并随时调用你的专属 AI 团队。',
  'visual_feature': '项目记录与团队空间安全同步',
  'reason_auth_required': '登录后即可继续当前操作',
  'reason_chat': '登录后即可发送消息并保存对话',
  'reason_knowledge': '登录后即可访问项目与知识库',
  'reason_assets': '登录后即可管理资产',
  'reason_account': '登录后即可查看和管理你的账号',
  'reason_subscription': '登录后即可查看订阅与套餐',
  'reason_invite': '登录后即可查看邀请奖励',
  'reason_image_recents': '登录后即可查看最近创作',
  'reason_upload': '登录后即可上传文件和参考图',
  'reason_image_generation': '登录后即可生成并保存图片',
  'reason_web_generation': '登录后即可生成并保存网页项目',
  'reason_payment_result': '登录后即可查看支付结果',
  'mobile_pc_guide_title': '请使用电脑访问\n体验Paiteams',
  'mobile_pc_guide_invite_title': '积分已发放\n请使用电脑访问\n体验Paiteams',
  'copyright': '© 2025 PAITEAMS. 保留所有权利。'
}
